import { Grid, Box } from "@mui/material";
import styled from "styled-components";
import LogoVecto from "../../Logo/LogoVecto";
import FormSondage from "./FormSondage";


const Sondage = () => {

    return (
        <Container className="bg2">
            <Grid container direction="row">
                <Grid className="wrapper-demie-logo wrapper-demie-logo-sondage"xs={12} sm={12} md={6} lg={6} xl={6}>
                    <LogoVecto />
                </Grid>
                <Grid className="wrapper-demie-contenu wrapper-demie-contenu-sondage" xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Box className="container-contenu" sx={{paddingRight: '0'}}>
                        <FormSondage />
                    </Box>
                </Grid>
            </Grid>
        </Container>

    );
};

const Container = styled.div`
    display: flex;
    padding: 1em;
    border-radius: 5px;
`


const Main = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2em;
    align-self: center;
`

const TopSubdivision = styled.div`
    display: flex;
`

const BottomSubdivision = styled.div`
    margin: auto;
    margin-top: 1em;
`


export default Sondage;